import * as B from '@blueprintjs/core';
import * as I from 'immutable';
import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {PushNotificationFn} from 'app/components/Notification';
import {ApiFeatureCollection} from 'app/modules/Remote/FeatureCollection';
import {ApiOrganization, ApiOrganizationUser} from 'app/modules/Remote/Organization';
import {ApiProject} from 'app/modules/Remote/Project';
import * as routeUtils from 'app/utils/routeUtils';

import PortfolioReports from './PortfolioReports';
import PortfolioShareLinks from './PortfolioShareLinks';

export type DocumentsPage = 'documents' | 'shareLinks';

/** The Documents tab: the portfolio's saved reports, or the share links to its properties. */
const PortfolioDocuments: React.FunctionComponent<{
  page: DocumentsPage;
  organization: I.ImmutableOf<ApiOrganization>;
  profile: I.ImmutableOf<ApiOrganizationUser>;
  selectedProject: I.ImmutableOf<ApiProject>;
  selectedFeatureCollection: I.ImmutableOf<ApiFeatureCollection>;
  pushNotification: PushNotificationFn;
}> = ({
  page,
  organization,
  profile,
  selectedProject,
  selectedFeatureCollection,
  pushNotification,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const viewToggle = (
    <B.SegmentedControl
      options={[
        {label: 'Reports', value: 'documents'},
        {label: 'Share links', value: 'shareLinks'},
      ]}
      value={page}
      onValueChange={(value) =>
        navigate(
          routeUtils.makeProjectDashboardUrl(
            organization.get('id'),
            selectedProject.get('id'),
            value as DocumentsPage,
            undefined,
            location.hash
          ),
          {replace: true}
        )
      }
    />
  );

  return page === 'shareLinks' ? (
    <PortfolioShareLinks
      organization={organization}
      profile={profile}
      selectedProject={selectedProject}
      selectedFeatureCollection={selectedFeatureCollection}
      pushNotification={pushNotification}
      viewToggle={viewToggle}
    />
  ) : (
    <PortfolioReports
      organization={organization}
      profile={profile}
      selectedProject={selectedProject}
      pushNotification={pushNotification}
      viewToggle={viewToggle}
    />
  );
};

export default PortfolioDocuments;
